<template>
    <div class="wheel-game">
        <div class="banner-container">
            <img v-if="$mecanic?.wheel_picture" :src="imgUrl($mecanic.wheel_picture, 'wheel')" alt="Bannière roue"
                class="banner-desktop hidden lg:block w-[70%] mx-auto" />
            <img v-if="$mecanic?.wheel_picture_mobile" :src="imgUrl($mecanic.wheel_picture_mobile, 'wheel')"
                alt="Bannière roue mobile" class="banner-mobile block lg:hidden w-[80%] mx-auto" />
        </div>

        <div v-if="$mecanic?.text_wheel2" class="w-[85%] md:w-[75%] mx-auto my-3 md:my-4">
            <p class=""
                v-html="$mecanic.text_wheel2">
            </p>
        </div>

        <div v-if="$mecanic?.text_wheel" class="w-[95%] md:w-[85%] mx-auto my-4 md:my-6">
            <div
                class="relative overflow-hidden bg-[#FE6E0F] border border-white/10 rounded-3xl p-4 shadow-lg border-4 border-white/20 ">
                <div
                    class="absolute top-[20%] left-[15%] w-12 h-12 md:w-16 md:h-16 bg-yellow-400 rounded-full blur-[20px] md:blur-[30px] opacity-70 pointer-events-none">
                </div>
                <div
                    class="absolute bottom-[20%] left-[45%] w-12 h-12 md:w-16 md:h-16 bg-yellow-200 rounded-full blur-[20px] md:blur-[30px] opacity-50 pointer-events-none">
                </div>
                <div class="relative z-10 text-center uppercase text-white font-extrabold text-sm md:text-xl lg:text-3xl tracking-wider leading-snug"
                    v-html="$mecanic.text_wheel">
                </div>
            </div>
        </div>

        <div
            class="p-6 my-6 md:my-8 bg-white/10 backdrop-blur-xl border border-white/10 rounded-2xl flex flex-col md:flex-row items-center gap-8 shadow-2xl">
            <div
                class="text-3xl font-bold w-[200px] md:w-[20%] text-[#EDC516] uppercase border-b-4 md:border-r-4 md:border-b-0 border-[#EDC516] pl-4 pb-2 md:pl-4 md:pb-0 italic">
                <p>Comment</p>
                <p>jouer ?</p>
            </div>
            <div class="flex flex-col md:flex-row items-center w-full md:w-[80%] gap-4">
                <div v-if="$mecanic?.instructions_1_wheel" class="instruction-item flex items-center w-full md:w-[33%]">
                    <p class="instruction-number">1</p>
                    <p class="!text-white font-bold" v-html="$mecanic.instructions_1_wheel"></p>
                </div>
                <div v-if="$mecanic?.instructions_2_wheel" class="instruction-item flex items-center w-full md:w-[33%]">
                    <p class="instruction-number">2</p>
                    <p class="!text-white font-bold" v-html="$mecanic.instructions_2_wheel"></p>
                </div>
                <div v-if="$mecanic?.instructions_3_wheel" class="instruction-item flex items-center w-full md:w-[33%]">
                    <p class="instruction-number">3</p>
                    <p class="!text-white font-bold" v-html="$mecanic.instructions_3_wheel"></p>
                </div>
            </div>
        </div>

        <div v-if="$mecanic?.instruction_wheel && !hasSpun" class="text-center mt-4 mb-6 px-4"
            v-html="$mecanic.instruction_wheel">
        </div>

        <div class="wheel-section relative w-full max-w-[600px] mx-auto px-4">
            <transition name="fade-up">
                <div class="w-full max-w-[420px] mx-auto z-20 relative">
                    <Form @submit="onSubmitEmail">
                        <InputText v-model="email" :required="true" label="" name="email" type="email"
                            placeholder="Votre adresse email" rules="required|email|max:50" :max="50"
                            :disabled="hasSubmittedEmail" :errors="errors" />
                        <p v-if="errorMessage" class="text-red-400 text-center mt-2 text-sm">{{ errorMessage }}</p>
                        <div class="flex justify-center mt-5">
                            <button type="submit" class="spin-button-submit"
                                :style="{
                                    backgroundColor: $mecanic.button_background_color_wheel || '#FE6E0F',
                                    color: $mecanic.button_text_color_wheel || '#ffffff'
                                }"
                                :disabled="isLoading || !email || hasSubmittedEmail">
                                {{ isLoading ? 'Vérification...' : 'Tourner la roue' }}
                            </button>
                        </div>
                    </Form>
                </div>
            </transition>

            <div v-if="formattedSlices.length > 0" class="wheel-wrapper mx-auto mt-6 mb-4"
                :class="{ 'pointer-events-none': !hasSubmittedEmail && !isSpinning }">

                <VueWheelSpinner ref="spinner" :slices="formattedSlices" :winner-index="winnerIndex"
                    :spin-duration="5000" cursor-position="edge" :cursor-angle="270" :width="560" :height="560"
                    :slice-font-style="sliceFontStyle" slice-text-position="edge" @spin-start="onSpinStart"
                    @spin-end="onSpinEnd">

                    <template #cursor>
                        <div class="wheel-cursor">
                            <svg width="40" height="30" viewBox="0 0 40 30">
                                <polygon points="20,30 0,0 40,0" fill="#FE6E0F" />
                            </svg>
                        </div>
                    </template>

                    <template #default>
                        <div class="wheel-center-static"></div>
                    </template>
                </VueWheelSpinner>
            </div>
        </div>
    </div>

    <div v-if="hasSpun" ref="endGameSection" class="w-full flex flex-col justify-center mt-4 text-center pb-6">
        <div v-if="isWinner">
            <div v-if="$mecanic?.end_text_wheel_win" v-html="tagText($mecanic.end_text_wheel_win, voucher)">
            </div>
            <button class="button-validation mt-6 text-xl" :style="{
                backgroundColor: $mecanic.button_background_color_wheel || '#FE6E0F',
                color: $mecanic.button_text_color_wheel || '#ffffff'
            }" @click="goToProducts">J'utilise mon bon
            </button>
        </div>
        <div v-else v-html="tagText($mecanic.end_text_wheel_loose, voucher)">
        </div>
        

        <div v-if="!isWinner" ref="endGameSection" class="w-full flex flex-col justify-center mt-4"
            style="scroll-margin-top: 500px;">
            <p class="m-auto w-fit sm:mt-4 font-bold text-[14px] lg:text-[24px]">Voici votre numéro de participation</p>
            <CodeTable v-if="code" :code="code" />
        </div>  
    </div>
</template>

<script>
import confetti from 'canvas-confetti'
import VueWheelSpinner from './VueWheelSpinner.vue'
import InputText from './Inputs/InputText.vue'
import { Form } from 'vee-validate'
import CodeTable from './CodeTable.vue'

export default {
    name: 'WheelGame',
    components: { VueWheelSpinner, InputText, Form, CodeTable },
    emits: ['winner', 'loser', 'emailSubmitted'],
    data() {
        return {
            email: '',
            errors: [],
            errorMessage: '',
            isLoading: false,
            hasSubmittedEmail: false,
            hasSpun: false,
            isSpinning: false,
            isWinner: false,
            voucher: null,
            winnerToken: null,
            winnerIndex: 0,
            apiResult: null,
            windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
        }
    },
    props: {
        code: String
    },
    computed: {
        sliceFontStyle() {
            const fontSize = this.windowWidth < 768 ? '20px' : '30px';
            return `900 ${fontSize} Arial, sans-serif`;
        },
        wheelSlices() {
            const vouchers = this.$template?.vouchers || this.$mecanic?.vouchers
            if (!Array.isArray(vouchers) || vouchers.length === 0) return []

            const losingCount = this.getLosingSliceCount(vouchers.length)
            const winningSlices = vouchers.map((voucher, index) => ({
                id: voucher.id,
                voucher_id: voucher.id,
                is_winner: true,
                color: this.getVoucherColor(voucher, index),
                text: this.getVoucherLabel(voucher),
                textColor: voucher.text_color || '#FFFFFF'
            }))

            const losingSlices = Array.from({ length: losingCount }, (_, index) => ({
                id: `lose-${index}`,
                is_winner: false,
                color: '#E53935',
                text: 'PERDU',
                textColor: '#FFFFFF'
            }))

            const slices = []
            let winnerCursor = 0
            let loserCursor = 0

            while (winnerCursor < winningSlices.length || loserCursor < losingSlices.length) {
                const winnerBurst = vouchers.length <= 6 ? 1 : 2

                for (let index = 0; index < winnerBurst && winnerCursor < winningSlices.length; index++) {
                    slices.push(winningSlices[winnerCursor])
                    winnerCursor += 1
                }

                if (loserCursor < losingSlices.length) {
                    slices.push(losingSlices[loserCursor])
                    loserCursor += 1
                }
            }

            return slices
        },
        formattedSlices() {
            return this.wheelSlices.map(slice => ({
                color: slice.color || '#CCCCCC',
                text: slice.text || 'PERDU',
                textColor: slice.textColor || '#FFFFFF'
            }))
        },
        utmData() {
            return this.$store.utms || {}
        }
    },
    methods: {
        triggerConfetti() {
            const duration = 3000;
            const end = Date.now() + duration;

            const frame = () => {
                confetti({
                    particleCount: 5,
                    angle: 270,
                    spread: 90,
                    origin: { 
                        x: Math.random(),
                        y: -0.1
                    },
                    // colors: ['#FE6E0F', '#EDC516', '#00AE83'] // Tes couleurs
                });

                if (Date.now() < end) {
                    requestAnimationFrame(frame);
                }
            };
            
            frame();
        },
        getLosingSliceCount(voucherCount) {
            if (voucherCount <= 6) {
                return Math.max(1, voucherCount)
            }

            return Math.max(1, Math.ceil(voucherCount / 2))
        },
        getVoucherColor(voucher, index) {
            if (voucher?.color) {
                return voucher.color
            }

            const palette = [
                '#1A56B6',
                '#FE6E0F',
                '#00AE83',
                '#D97706',
                '#7C3AED',
                '#0EA5E9'
            ]

            return palette[index % palette.length]
        },
        getVoucherLabel(voucher) {
            if (voucher?.wheel_label) {
                return voucher.wheel_label
            }

            if (voucher?.name) {
                return voucher.name
            }

            if (voucher?.value !== null && voucher?.value !== undefined) {
                return `-${voucher.value}€`
            }

            return 'BON'
        },
        validateEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        async onSubmitEmail() {
            if (this.isLoading) return
            this.errorMessage = ''
            this.errors = []

            if (!this.email || !this.validateEmail(this.email)) {
                this.errors = { email: ['Veuillez entrer un email valide'] }
                return
            }

            this.isLoading = true

            try {
                const response = await this.$api.wheelSpin(this.$campaign.id, this.$store.idLanding, this.email, this.utmData, this.$store.optinVariant)
                if (response.status === 422) {
                    this.errors = response.data.errors || {}
                    this.errorMessage = response.data.errors ? '' : (response.data.message || 'Une erreur est survenue.')
                    this.isLoading = false
                    return
                }
                if (response.data.error_type === 'already_played' || response.data.error_type === 'already_participated') {
                    this.errorMessage = response.data.message || 'Vous avez déjà participé à ce jeu avec cet email.'
                    this.isLoading = false
                    return
                }

                this.apiResult = response.data
                this.isWinner = response.data.is_winner
                this.voucher = response.data.voucher?.data || response.data.voucher
                this.winnerToken = response.data.token
                this.winnerIndex = this.getTargetSliceIndex(response.data.is_winner, this.voucher?.id)

                this.hasSubmittedEmail = true
                this.$emit('emailSubmitted', this.email)

                this.$nextTick(() => {
                    setTimeout(() => {
                        this.spinWheel()
                    }, 300)
                })
            } catch (error) {
                console.error('Error spinning wheel:', error)
                this.errorMessage = 'Une erreur est survenue. Veuillez réessayer.'
            }
            this.isLoading = false
        },
        getTargetSliceIndex(isWinner, voucherId = null) {
            const slices = this.wheelSlices
            if (isWinner) {
                if (voucherId !== null && voucherId !== undefined) {
                    const targetIndex = slices.findIndex(slice => slice.is_winner && String(slice.voucher_id) === String(voucherId))
                    if (targetIndex !== -1) return targetIndex
                }

                const indices = slices.map((s, i) => s.is_winner ? i : -1).filter(i => i !== -1)
                if (indices.length) return indices[Math.floor(Math.random() * indices.length)]
            } else {
                const indices = slices.map((s, i) => !s.is_winner ? i : -1).filter(i => i !== -1)
                if (indices.length) return indices[Math.floor(Math.random() * indices.length)]
            }
            return 0
        },
        spinWheel() {
            if (this.isSpinning || this.hasSpun || !this.$refs.spinner) return
            this.$refs.spinner.spinWheel(this.winnerIndex)
        },
        onSpinStart() {
            this.isSpinning = true
        },
        onSpinEnd() {
            this.isSpinning = false
            this.hasSpun = true

            if (!this.isWinner) {
                this.$emit('loser')
            } else {
                this.$emit('winner')
                this.triggerConfetti()
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.endGameSection?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 500);
            });

            if (this.isWinner && this.winnerToken) {
                this.$store.setWinnerData({
                    token: this.winnerToken,
                    email: this.email,
                    voucher: this.voucher,
                    isWinner: true
                })
            } else{
                this.$store.clearWinnerData()
            }
        },
        goToProducts() {
            this.$router.replace({ name: 'product' })
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    },
    mounted() {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.handleResize);
        }
    },
    beforeUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.handleResize);
        }
    },
}
</script>

<style scoped>
.wheel-game {
    background-image: v-bind("$mecanic?.background_wheel ? `url(${imgUrl($mecanic.background_wheel, 'wheel')})` : 'none'");
    background-color: #1a56b6;
    /* Fallback bleu comme la maquette */
    background-position: center;
    min-height: 100vh;
    @apply p-4 md:p-6 bg-auto md:bg-cover;
}

@media (max-width: 1024px) {
    .wheel-game {
        background-image: v-bind("$mecanic?.background_wheel_mobile ? `url(${imgUrl($mecanic.background_wheel_mobile, 'wheel')})` : ($mecanic?.background_wheel ? `url(${imgUrl($mecanic.background_wheel, 'wheel')})` : 'none')");
    }
}

.instruction-number {
    @apply bg-[#FE6E0F] text-white rounded-full w-[40px] h-[40px] flex items-center justify-center text-lg font-bold mr-3 flex-shrink-0 border-2 border-white;
}

.wheel-wrapper {
    width: 100%;
    max-width: 560px;
    transition: opacity 0.3s ease;
    padding: 10px;
}

.wheel-wrapper :deep(canvas) {
    border-radius: 50%;
    border: 6px solid #ffffff;
    box-shadow: 0 0 0 6px #FE6E0F, 0 4px 15px rgba(0, 0, 0, 0.3);
}

.wheel-cursor {
    filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.4));
    transform: translateY(-55px); 
    z-index: 20;
    position: relative;
}

.wheel-center-static {
    width: 48px;
    height: 48px;
    margin: 0 auto;
    background-color: white;
    border-radius: 50%;
    border: 12px solid #FE6E0F;
    box-shadow: 0 0 0 3px white;
    z-index: 11;
    position: relative;
}

.spin-button-submit {
    @apply flex-1 py-3 rounded-xl font-black text-lg uppercase tracking-widest shadow-2xl transition-all active:scale-95;
}

.spin-button-submit:disabled {
    background: #888 !important;
    box-shadow: none;
}

.button-validation {
    @apply py-3 px-8 rounded-full font-black text-lg shadow-xl transition-transform hover:scale-105;
}

.fade-up-enter-active,
.fade-up-leave-active {
    transition: all 0.4s ease;
}

.fade-up-enter-from,
.fade-up-leave-to {
    opacity: 0;
    transform: translateY(16px);
}
</style>